import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import userReducerSlice from "./slices/userSlice";
import siteReducerSlice from "./slices/siteSlice";
import analyticsSlice from "./slices/analyticsSlice";
import sftpUserSlice from "./slices/sftpSlice";
import backupSlice from "./slices/backupSlice";
import activitiesSlice from "./slices/activitiesSlice";
import gitSlice from "./slices/gitSlice";
import deploymentSlice from "./slices/deploymentSlice";
import cacheSlice from "./slices/cacheSlice";
import pluginsSlice from "./slices/pluginsSlice";
import migrationSlice from "./slices/migrationSlice";
import userManagementSlice from "./slices/userManagementSlice";
import applicationSlice from "./slices/applicationSlice";
import planSlice from "./slices/planSlice";
import notificationSlice from "./slices/notificationSlice";
import adminSlice from "./slices/adminSlice";
import orgSlice from "./slices/orgSlice";
import billingSlice from "./slices/billingSlice";
import usageSlice from "./slices/usageSlice";
import externalMigrationSlice from "./slices/externalMigrationSlice";
import apmSlice from "./slices/apmSlice";
import monitoringSlice from "./slices/monitoringSlice";

// Persist configuration - persist user and org state
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["user", "org"], // Persist user and org slices
};

const appReducer = combineReducers({
  user: userReducerSlice,
  site: siteReducerSlice,
  analytics: analyticsSlice,
  sftp: sftpUserSlice,
  backup: backupSlice,
  activities: activitiesSlice,
  git: gitSlice,
  deployment: deploymentSlice,
  cache: cacheSlice,
  plugins: pluginsSlice,
  migration: migrationSlice,
  userManagement: userManagementSlice,
  applications: applicationSlice,
  plan: planSlice,
  notification: notificationSlice,
  admin: adminSlice,
  org: orgSlice,
  billing: billingSlice,
  usage: usageSlice,
  externalMigration: externalMigrationSlice,
  apm: apmSlice,
  monitoring: monitoringSlice,
});

// Reset ALL state on logout to prevent stale data from previous user sessions
const rootReducer = (state, action) => {
  if (action.type === "user/logout") {
    storage.removeItem("persist:root");
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export const persistor = persistStore(store);
export default store;
